import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  LinearProgress,
  MenuItem,
  Slide,
  TextField,
} from "@mui/material";

import React, { useState } from "react";
import { Box } from "@mui/system";
import { IoCloseOutline } from "react-icons/io5";
import Utils from "../utils";
import { createPayroll, updatePayroll } from "../services/payroll.service";
import Constants from "../data/Constants";
import * as yup from "yup";
import { useFormik } from "formik";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function CreatePayrollDialog(props) {
  const { onCreate, onClose, open, mentors, onError } = props;

  const [status, setStatus] = useState({
    loading: false,
    error: false,
    success: false,
  });

  const defaultPayroll = {
    mentorId: "",
    comment: "",
    amount: "",
    status: "PROCESSING",
  };

  const validationSchema = yup.object({
    mentorId: yup.string().required().label("Mentor"),
    amount: yup.number().required().label("Amount").min(0).max(10000),
    comment: yup.string().required().label("Comment").min(1).max(1000),
  });

  const formik = useFormik({
    initialValues: defaultPayroll,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      formSubmitHandler(values);
    },
  });

  const handleClose = () => {
    formik.resetForm();
    onClose();
  };

  const formSubmitHandler = async (values) => {
    try {
      setStatus({
        loading: true,
        error: false,
      });

      const data = await createPayroll(values);

      setStatus({
        loading: false,
        error: false,
        success: true,
        message: "Payout Created Successfully",
      });

      onCreate(values);

      handleClose();
    } catch (error) {
      // error
      setStatus({
        loading: false,
        error: true,
        message: Utils.CustomErrorMessage(error),
      });

      onError(Utils.CustomErrorMessage(error));
    }
  };

  return (
    <Dialog
      open={open ? true : false}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <Box flexGrow={1}>
            <h2 className="font-extrabold text-lg">Create new Payout</h2>
          </Box>
          <Box>
            <IconButton onClick={handleClose}>
              <IoCloseOutline />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <div className="flex flex-col gap-4">
          <TextField
            label="Mentor"
            variant="filled"
            size="small"
            fullWidth
            name="mentorId"
            onBlur={formik.handleBlur}
            error={formik.touched.mentorId && Boolean(formik.errors.mentorId)}
            helperText={formik.touched.mentorId && formik.errors.mentorId}
            value={formik.values.mentorId}
            onChange={formik.handleChange}
            select
            required
          >
            {mentors &&
              mentors.map((mentor, index) => {
                return (
                  <MenuItem key={index} value={mentor._id}>
                    {mentor.firstname +
                      " " +
                      mentor.lastname +
                      " (" +
                      mentor._id.slice(0) +
                      ")"}
                  </MenuItem>
                );
              })}
          </TextField>

          <TextField
            label="Amount"
            variant="filled"
            type="number"
            size="small"
            value={formik.values.amount}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.amount && Boolean(formik.errors.amount)}
            helperText={formik.touched.amount && formik.errors.amount}
            required
            name="amount"
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  {Constants.CURRENCY_SYMBOL}
                </InputAdornment>
              ),
            }}
          />

          <TextField
            label="Comment"
            variant="filled"
            size="small"
            value={formik.values.comment}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.comment && Boolean(formik.errors.comment)}
            helperText={formik.touched.comment && formik.errors.comment}
            className="col-span-2"
            name="comment"
            multiline
            rows={3}
            required
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Back</Button>

        <Button color="success" onClick={formik.handleSubmit} type="submit">
          Payout
        </Button>
      </DialogActions>
      {status.loading ? (
        <Box>
          <LinearProgress />
        </Box>
      ) : (
        ""
      )}
    </Dialog>
  );
}

export default CreatePayrollDialog;
